<!--
/**
 * Author: David Schiefer
 * Department: ITS Development Tax

 * Generic Buttons a cancel and a save button per default can be used in several ways
 * the generics use them in dynamic form and dynamic dialog
 *
 */
!-->
<template>
    <v-card-actions>
        <slot name="prepend"></slot>
        <v-spacer></v-spacer>
        <v-btn
            v-if="cancel"
            :color="cancelColor"
            :disabled="cancelDisabled"
            :text="cancelText"
            :variant="cancelVariant"
            :loading="cancelIsLoading"
            @click="emitCancel"
        />
        <v-btn
            v-if="confirm"
            :color="confirmColor"
            :disabled="confirmDisabled"
            :text="confirmText"
            :variant="confirmVariant"
            type="submit"
            :loading="confirmIsLoading"
            @click="emitSave"
        />
        <slot name="append"></slot>
    </v-card-actions>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {ActionBtnProps} from "@/components/generics/ActionBtn/ActionBtnProps";

export default defineComponent({
    emits: ['cancel', 'save'],
    props: ActionBtnProps,
    setup(props, {emit}) {
        const emitCancel = (): void => {
            emit("cancel");
        }
        const emitSave = (): void => {
            emit("save");
        }

        return {
            //action
            emitCancel,
            emitSave,
        }
    },
})
</script>
